import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Location } from "@angular/common";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { Cookie } from "../cookie/cookie.enum";

@Injectable()
export class UtilityService {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  redirectToServicePage() {
    let redirectURL: string;

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      redirectURL = params["service"];
    });
    if (redirectURL == null) {
      location.replace(Cookie.PrcUrl);
    } else {
      redirectURL = this.getParameterByName("service");
      location.replace(redirectURL);
    }
  }

  redirectToLoginPage() {
    let param: string;

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      param = params["service"];

      if (param) {
        this.router.navigate(["/login"], { queryParams: { service: param } });
      } else {
        this.router.navigate(["/login"]);
      }
    });
  }

  queryParam(param) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      return params[param];
    });
  }

  getParameterByName(name, url?) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // Observable string sources
  private emitChangeLoading = new Subject<any>();

  // Observable string streams
  loadingChangeEmitted$ = this.emitChangeLoading.asObservable();

  // Service message commands
  loadingEmitChange(change: any) {
    this.emitChangeLoading.next(change);
  }
}
